import cx from 'classnames'
import { HelpDropdown } from 'blaze-components/TopBar/HelpDropdown/HelpDropdown'
import Styles from './Header.module.scss'
import { HeaderProps } from './Types'
import { Button } from 'blaze-ui/Button'
import { Close, Help } from 'blaze-ui/icons'

export const Header = ({ title, icon: Icon, onBack, onClose, isScrolled = false, type }: HeaderProps) => {
  return (
    <div className={cx(Styles.root, { [Styles.isScrolled]: isScrolled })}>
      <div className={Styles.cancelContainer}>
        {onBack && (
          <Button variant="ghost" size="lg" onPress={onBack}>
            Back
          </Button>
        )}
      </div>
      <div className={Styles.titleContainer}>
        {!!Icon && <Icon size={20} />}
        <h4 className={Styles.title}>{title}</h4>
      </div>
      <div className={Styles.topButtons}>
        <HelpDropdown
          videoTutorialType={type}
          trigger={<Button variant="tertiary" size="md" frontIcon={Help} rounded />}
        />
        {onClose && (
          <Button onPress={onClose} variant="tertiary" size="md" frontIcon={Close} rounded aria-label="Cancel" />
        )}
      </div>
    </div>
  )
}
